import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "utils/useDidMountEffect";
import useAfterUpdateEffect from "utils/useAfterUpdateEffect";
import TextLinkType from "../../../TextLinkType";
import MainWork from "./MainWork";
import AdditionalWork from "./AdditionalWork";

const MaintenancePlan = props => {
  const [maintenancePlanDataServiceWorkPositions, setMaintenancePlanDataServiceWorkPositions] = useState([])
  const [maintenancePlanDataAdditionalWorkPositions, setMaintenancePlanDataAdditionalWorkPositions] = useState([])

  useDidMountEffect(() => {
    setMaintenancePlanDataServiceWorkPositions(props.maintenancePlanData.ServiceWorkPositions.map(serviceWorkPosition => parseServiceWorkPosition(serviceWorkPosition)))
    setMaintenancePlanDataAdditionalWorkPositions(props.maintenancePlanData.AdditionalWorkPositions.map(serviceWorkPosition => parseServiceWorkPosition(serviceWorkPosition)))
  })

  useAfterUpdateEffect(() => {
    setMaintenancePlanDataServiceWorkPositions(props.maintenancePlanData.ServiceWorkPositions.map(serviceWorkPosition => parseServiceWorkPosition(serviceWorkPosition)))
  }, [props.maintenancePlanData.ServiceWorkPositions])

  useAfterUpdateEffect(() => {
    setMaintenancePlanDataAdditionalWorkPositions(props.maintenancePlanData.AdditionalWorkPositions.map(serviceWorkPosition => parseServiceWorkPosition(serviceWorkPosition)))
  }, [props.maintenancePlanData.AdditionalWorkPositions])

  const parseServiceWorkPosition = (serviceWorkPosition) => {
    serviceWorkPosition.ServicePlanPositions = serviceWorkPosition.ServicePlanPositions
      .map((servicePlanPosition, key) => {
        const servicePlanPosition_next = serviceWorkPosition.ServicePlanPositions[key+1]
        servicePlanPosition.PositionTextDisplay = servicePlanPosition.PositionText
        if(servicePlanPosition_next && servicePlanPosition_next?.AmountLinkType !== 32){
          servicePlanPosition.PositionText = `${servicePlanPosition.PositionText} (${servicePlanPosition_next.Amount})`
          servicePlanPosition.PositionTextDisplay = <span>
            <span>{servicePlanPosition.PositionTextDisplay}</span>
            <span>
              {
                servicePlanPosition_next.Amount
                  ? <TextLinkType
                    linkType={servicePlanPosition_next.AmountLinkType}
                    linkValue={servicePlanPosition_next.AmountLinkValue}
                  > ( {servicePlanPosition_next.Amount} )</TextLinkType>
                  : ''
              }
            </span>
          </span>
        }

        if(
          servicePlanPosition?.AmountLinkType !== 32
          || servicePlanPosition?.SortNo < 0
        ){
          return false
        }

        return servicePlanPosition
      })
      .filter(servicePlanPosition => !!servicePlanPosition)

    return serviceWorkPosition
  }

  return (
    <div>
      {maintenancePlanDataServiceWorkPositions.map((servicePlanPosition, key) => {
        const serviceWork = props.works.Services.find(service => service.WorkSteps.find(workStep => workStep.WorkId === servicePlanPosition.WorkId)).WorkSteps[0]

        return <MainWork
          bodyForTimes={props.bodyForTimes}
          servicePlanPosition={servicePlanPosition}
          serviceWork={serviceWork}
        />
      })}


      {maintenancePlanDataAdditionalWorkPositions.map((additionalWorkPosition, key) => {
        const additionalWork = props.works.AdditionalWorks.find(additionalWork => additionalWork.WorkSteps.find(workStep => workStep.WorkId === additionalWorkPosition.WorkId)).WorkSteps[0]

        return <AdditionalWork
          bodyForTimes={props.bodyForTimes}
          additionalWorkPosition={additionalWorkPosition}
          additionalWork={additionalWork}
        />
      })}
    </div>
  );
};

MaintenancePlan.propTypes = {
  bodyForTimes: PropTypes.number.isRequired,
  maintenancePlanData: PropTypes.shape({
    ServiceWorkPositions: PropTypes.arrayOf(PropTypes.shape({

    }),),
  }).isRequired,
};

export default MaintenancePlan;